import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"
import { useLayerUnseededCodes } from "@/v2-backoffice-client/layer/authoring/layer.authoring.unseeded"

export type LayerUnseededBannerProps = {
  className?: string
}

/**
 * Catalog rows that aren't in this runtime yet (created here but never
 * published, or seed-skipped). A slim banner instead of pseudo-rows: the
 * table stays a truthful view of the runtime, and the fix is always the
 * same — run Publish catalog.
 */
function LayerUnseededBanner(props: LayerUnseededBannerProps) {
  const { className } = props

  const unseededCodes = useLayerUnseededCodes()
  if (unseededCodes.length === 0) return null

  return (
    <p
      className={cn(
        "layer-unseeded-banner flex items-center gap-1.5 rounded-md border border-amber-500/50 bg-amber-500/10 px-2.5 py-1.5 text-xs",
        className,
      )}
      title={unseededCodes.join(", ")}
    >
      <Icon src="triangle-warning" size={12} className="shrink-0" />
      {unseededCodes.length} catalog{" "}
      {unseededCodes.length === 1 ? "layer" : "layers"}
      {" aren't in this runtime yet — run Publish catalog to seed "}
      {unseededCodes.length === 1 ? "it" : "them"}.
    </p>
  )
}

export default LayerUnseededBanner
